import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { TriggerProps } from '@atlaskit/popup/types';
import type { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import type { ProductConfig } from '../../../common/constants/products';
import { FilterButton } from '../../../common/ui/quick-find/filter-button';
import type { OnAppFilterSelectedCallback } from './filters-row-types';

export const AppButton3P = ({
	productConfig,
	userNeedsAuth,
	triggerProps,
	onAppFilterSelected,
	productKey,
}: {
	productConfig: ProductConfig;
	userNeedsAuth: boolean;
	triggerProps?: TriggerProps;
	onAppFilterSelected: OnAppFilterSelectedCallback;
	productKey: ProductKeys3P;
}): React.JSX.Element => {
	const Icon = productConfig.IconBorderless ?? productConfig.Icon;

	return (
		<FilterButton
			{...triggerProps}
			iconBefore={<Icon size={'xsmall'} />}
			contentFit={'default'}
			isSelected={false}
			spacing={'default'}
			gap={fg('rovo-search-team-eu-26-search-app') ? 'default' : 'comfortable'}
			onClick={(event) => {
				if (!userNeedsAuth) {
					onAppFilterSelected(
						productKey,
						{
							redirectToFPS: true,
							isPostAuthAction: false,
						},
						event,
					);
				}
			}}
		>
			{productConfig.displayName}
		</FilterButton>
	);
};
